import React, { Component } from "react";
import { Input, Form, Select } from "@rocketseat/unform";
import Base from "../../../components/Base";
import MaskedField from "../../../components/MaskedField";
import cpfMask from "../../../components/Masks/Cpf";
import CurrencyField from "../../../components/CurrencyField";

import "./styles.css";
import { Button, Modal, Col, Row, Icon, notification } from "antd";
import api from "../../../services/api";
import handleError from "../../../services/apiErrorHandler";
import CadContainer from "./CadContainer";
import * as Yup from "yup";

export default class SancorCadastro extends Component {
  state = {
    loading: false,
    cooperado_mask: cpfMask(""),
    form_inputs: document.getElementsByClassName("ant-input")
  };

  /** Remove o "erro" do campo quando alterado */
  componentDidMount() {
    Array.from(this.state.form_inputs).forEach(inp => {
      inp.addEventListener("change", event => {
        let element = event.target;
        if (element.classList.contains("input-error"))
          element.classList.remove("input-error");
      });
    });
  }

  componentWillUnmount() {
    Array.from(this.state.form_inputs).forEach(inp => {
      inp.removeEventListener("change", event => {
        let element = event.target;
        if (element.classList.contains("input-error"))
          element.classList.remove("input-error");
      });
    });
  }

  /** CPF/CNPJ input mask */
  handleCooperadoCpfChange = event => {
    this.setState({
      cooperado_mask: cpfMask(event.target.value)
    });
  };

  /**
   * Altera o estilo dos campos errados (red border)
   * @param {object} error - Resposta do servidor
   */
  handleInputErrors = error => {
    if (error.response) {
      if (!error.response.data) return;
      if (!error.response.data.invalid_fields) return;
      let invalid_fields = error.response.data.invalid_fields;
      invalid_fields.map(value => {
        try {
          document.getElementsByName(value)[0].classList.add("input-error");
        } catch (error) {}
      });
    }
  };

  /**
   * Envia os dados para o back-end
   * @param {object} data - Dados do formulário
   */
  handleSubmit = async data => {
    console.log(data);
    this.setState({
      loading: true
    });

    await api
      .post("/pasta/pastas/", data)
      .then(response => {
        notification.success({
          message: "Cadastro efetuado com sucesso!"
        });
        setTimeout(() => {
          location.reload();
        }, 2000);
      })
      .catch(error => {
        this.handleInputErrors(error);
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });
    this.setState({
      loading: false
    });
  };

  /** Campos do formulário */
  schema = {
    pasta: Yup.string(),
    tipo_cobranca: Yup.string(),
    singular: Yup.string(),
    cpf_cnpj: Yup.string(),
    cooperado: Yup.string(),
    agencia: Yup.string(),
    email: Yup.string(),
    conta: Yup.string(),
    telefone: Yup.string(),
    endereco: Yup.string()
  };

  /** Dados iniciais no formulário */
  innitialData = {
    tipo_cobranca: "-1",
    singular: "-1"
  };

  yup_schema = Yup.object().shape(this.schema);

  render() {
    return (
      <div className="cad_sancor">
        <Base title="Cadastro">
          {/**
           * Componente Form da biblioteca "Unform"
           * https://github.com/Rocketseat/unform
           */}
          <Form
            onSubmit={this.handleSubmit}
            schema={this.yup_schema}
            initialData={this.innitialData}
          >
            <CadContainer title="Dados do Contrato">
              <Row gutter={24}>
                <Col sm={{ span: 12 }}>
                  <div className="d-flex cad_sancor__input">
                    <label>Pasta:</label>
                    <Input type="text" name="pasta" className="ant-input" />
                  </div>
                  <div className="d-flex cad_sancor__input">
                    <label>Instituição:</label>
                    <Select
                      name="singular"
                      className="ant-input"
                      options={[
                        { id: -1, title: "Selecione" },
                        { id: "OURO VERDE", title: "OURO VERDE" },
                        { id: "COOPMIL", title: "COOPMIL" },
                        { id: "BRADESCO-PR", title: "BRADESCO-PR" },
                        { id: "BRADESCO-SC", title: "BRADESCO-SC" },
                        { id: "BRADESCO-OUTROS", title: "BRADESCO-OUTROS" },
                        { id: "SISPRIME", title: "SISPRIME" },
                        { id: "ORALSIN", title: "ORALSIN" },
                        { id: "ESPD", title: "ESPD" },
                        {
                          id:
                            "ESPE - ENSINO SUPERIOR EM PSICOLOGIA E EDUACAÇÃO",
                          title:
                            "ESPE - ENSINO SUPERIOR EM PSICOLOGIA E EDUACAÇÃO"
                        }
                      ]}
                    />
                  </div>
                  <div className="d-flex cad_sancor__input">
                    <label>Agencia:</label>
                    <Input type="text" name="agencia" className="ant-input" />
                  </div>
                  <div className="d-flex cad_sancor__input">
                    <label>Conta:</label>
                    <Input type="text" name="conta" className="ant-input" />
                  </div>
                </Col>
                <Col sm={{ span: 12 }}>
                  <div className="d-flex cad_sancor__input">
                    <label>Devedor:</label>
                    <Input type="text" name="cooperado" className="ant-input" />
                  </div>
                  <div className="d-flex cad_sancor__input">
                    <label>CPF/CNPJ:</label>
                    <MaskedField
                      name="cpf_cnpj"
                      className="ant-input"
                      mask={this.state.cooperado_mask}
                      type="text"
                      customfunction={event =>
                        this.handleCooperadoCpfChange(event)
                      }
                    />
                  </div>
                  <div className="d-flex cad_sancor__input">
                    <label>Endereco:</label>
                    <Input type="text" name="endereco" className="ant-input" />
                  </div>
                  <div className="d-flex cad_sancor__input">
                    <label>Email:</label>
                    <Input type="text" name="email" className="ant-input" />
                  </div>
                  <div className="d-flex cad_sancor__input">
                    <label>Telefone:</label>
                    <Input type="text" name="telefone" className="ant-input" />
                  </div>
                </Col>
              </Row>
            </CadContainer>
            <div
              className="d-flex"
              style={{ justifyContent: "flex-end", margin: "10px" }}
            >
              {/** Botão de submit */}
              <Button
                htmlType="submit"
                type="primary"
                loading={this.state.loading}
              >
                {this.state.loading ? null : <Icon type="save" />} Salvar
              </Button>
            </div>
          </Form>
        </Base>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Sancor/Cadastro/index.js